<template>
    <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6">
              <h2 class="card-title">Plan de Prévention Evolutif</h2>
        </div>
      </div>
      <router-link class="btn btn-secondary btn-sm " to="/login">← S'identifier</router-link> 
      <div class="row">
        
        

          <FormulateForm class="col-md-6" @submit="onSubmit" v-model="form" >
            <card class="bg-light login-bloc">
              <template slot="header">
                <h4 class="card-title">Réinitialisez votre mot de passe</h4>
                <p class="card-category">Veuillez entrer un nouveau mot de passe</p>
              </template>
              
              <FormulateInput
                label="Nouveau mot de passe"
                type="password"
                name="password"
                validation="required|min:6,length|matches:/[0-9]/"
              />
              <FormulateInput
                label="Confirmez le mot de passe"
                type="password"
                name="password_confirm"
                validation="required|confirm"
                validation-name="Password confirmation"
              />


             

              <b-form-group class="float-right">
                <b-button type="submit" variant="primary">Changer mon mot de passe</b-button>
              </b-form-group>

            </card>


        </FormulateForm>
        
      </div>
      <p></p>
      <p></p>
    </div>
    </div>    
</template>
<style scoped>
.login-bloc {
  height: 250pt;
}
</style>
<script>
import swal from "sweetalert";
import common from './common/pages.js'

export default {
  components: {
    
  },
  data() {
    return  {
        form : {
        password : '',
        password_confirm : ''
        }
    }
  },
    methods: {
      ...common.methods,
      async onSubmit(event) {
        //event.preventDefault()
        console.log("JSON.stringify(this.form)",JSON.stringify(this.form))

        try {
          //console.log("BEFORE LOGIN", this.form)
          let response = await this.$http.post("/user/changepassword?uniqueid="+this.$route.params.uniqueid, this.form );

          swal({title:"Mot de passe modifié", text:"Vous pouvez vous identifier", icon:"success", buttons: 'OK'} );
          this.$router.push("/login/"+response.data.email)

        } catch (err) {
          console.log(err.response.data);
          swal("Erreur", err.response? (err.response.data.error) : JSON.stringify(err), "error");
        }
      },
    }
}
</script>
